import React, { Component } from "react";
// import { Helmet } from "react-helmet";
// import Footer from 'components/Footer/Footer';
import './style.css';
import 'pages/PKList/style.css';
// import PKimg from 'Assets/pksuccess.svg';
import { Row, Col, Button } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
//import Button from "components/Button/Button";
import Table from 'react-bootstrap/Table';
import { user_access_level, organization_user_access_level, user_account_level, apiUrl, searchUrl, org_friendly_url, user_entity_uuid, user_Status, user_Status_Ver, myHeaders_Auth_With_Cache_Control } from "Api/Api";
// , myHeaders_With_Cache_Control, presentation_Creation_API, user_API
import axios from "axios";
//import { getKey, dateConvert, unixDateConversion,origin, current_unix_stamp } from 'utils/Helper';
import { getKey, get_current_unix_stamp } from 'utils/Helper';
// , dateConvert, unixDateConversion
// import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import EmptyMessage from 'components/EmptyMessage/EmptyMessage';
//import PkListTable from 'components/PkListTable/PkListTable';
import PkListTableV2 from 'components/PkListTable/PkListTableV2';
import { withRouter } from "react-router-dom";
import TableHeader from 'components/Table/TableHeaderV2';
// import home from 'Assets/home.svg';
import { local_routes } from 'utils/Routes';

import UserContext from 'store/UserContext';

class PkList extends Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        //this.pagination_limit = 100;
        //this.default_pagination_from = 0;
        this.state = {
            search_text: '',
            table_loading: true,
            loading: true,
            //pagination_from: this.default_pagination_from,
            presentations_get_from: 0,
            presentations_get_limit: 20,
            presentations_get_total: null,
            presentations_array: [],
            presentations_page_number: 1,
            //loading: true,
            tableHeader: { 'Title': '', 'Events': '', 'Created On': '', 'Notes': '', 'Published': '', 'Privacy': '', 'Assets': '', 'Edit': '' },
            
            draftData: [],
            publishData: [],
            date: [],
            //pageLoader: true,
            validated: false,
            //pkLink: '',
            copied: false,
            //pendingData:[],
            //friendlyPkUrl:null,
            status_code:null,
            messages:[],
            source_info: props.source_info,
            //community_events_by_format: {}
        }
        
        if (this.state.source_info.entity_type === 'organizations') {
            this.state.tableHeader = { 'Title': '', 'Creator': '', 'Events': '', 'Created On': '', 'Notes': '', 'Published': '', 'Privacy': '', 'Assets': '', 'Edit': '' };
        }
        
        
        
        this.workspace_base_url = "";
        //const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
          //this.state.tableHeader = { 'Title': '', 'Event': '', 'Created On': '', 'Notes': '', 'Public': '' }
        }
        
        this.auto_refresh_time = 30; // seconds
        
        //this.interval = setInterval(() => this.setState({ time: Date.now() }), 5000);
    }
    
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    
    // Api Integration Strats here
    componentDidMount() {
        console.log("PkList componentDidMount");
        //if (this.props.friendlyurl !== undefined && !null) {
        //    this.setState({ friendlyPkUrl: this.props.friendlyurl,  pkLink:`${origin}/player/${this.props.friendlyurl}` })
        //}
        //window.scrollTo(0, 0);
        //this.interval = setInterval(() => this.setState({ time: Date.now() }), 1000);
        
        if (user_Status === 1) {

            //this.userPkMet();
            this.APICalls();
            this.interval = setInterval(() => this.APICalls(), this.auto_refresh_time * 1000);
        } else {
            //this.setState({ pageLoader: true })
            window.location.href = '/';
        }
        
    }
    // Api Integration Ends here

    APICalls = async (config = {}) => {
        console.log("PkList APICalls",config);
        //this.state.messages = getKey('PKListMessage');
        //if (this.state.messages) {
        //    window.localStorage.removeItem('PKListMessage');
        //}
        
        let new_state = {...this.state};
        
        let query_filter = "all";
        if ('search_text' in config) {
            query_filter = config.search_text;
            new_state.search_text = config.search_text;
        } else if (this.state.search_text) {
            query_filter = this.state.search_text;
        }
        if (query_filter === "") {
            query_filter = "all";
        }
        
        /*
        let pagination_from = this.default_pagination_from;
        if ('pagination_from' in config) { // could be 0
            pagination_from = config.pagination_from;
            new_state.pagination_from = pagination_from;
        } else {
            pagination_from = this.state.pagination_from;
        }
        */
        
        if ('presentations_get_from' in config) {
            new_state.presentations_get_from = config.presentations_get_from;
            //console.log(" YO",new_state.presentations_get_from)
        }
        if (config.presentations_page_number) {
            new_state.presentations_page_number = config.presentations_page_number;
        }
        
        if (getKey('PKListMessage')) {
            new_state.messages = getKey('PKListMessage');
            window.localStorage.removeItem('PKListMessage');
        } else {
            new_state.messages = [];
        }
        //console.log(`${user_API}/${user_entity_uuid}/presentations?sort[created_time]=asc&filter[entity_owner_integer][gte]=1`)
        //axios.get(`${user_API}/${user_entity_uuid}/presentations?sort[created_time]=asc&filter[entity_owner_integer][gte]=1`, myHeaders_With_Cache_Control)
        
        let api_promises = [];
        
        if (new_state.source_info.entity_type === 'users') {
            let params = {
                do_recursive: true,
                from: new_state.presentations_get_from,
                limit: new_state.presentations_get_limit,
                sort_obj: {
                    created_time: 'desc'
                },
                filter_obj: {
                    status_code: {
                        ne: 2
                    },
                    entity_owner_integer: {
                        gte: 1
                    }
                }
            };
            if (query_filter !== 'all') {
                params.filter_obj.entity_name = { contains: query_filter };
            }            
            
            //api_promises.push(axios.get(`${apiUrl}${new_state.source_info.entity_type}/${new_state.source_info.entity_uuid}/presentations?do_recursive=true&from=${new_state.presentations_get_from}&limit=${new_state.presentations_get_limit}&sort_obj=${encodeURIComponent('{"created_time":"desc"}')}&filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1},"status_code":{"ne":2}}')}`, myHeaders_Auth_With_Cache_Control));
            api_promises.push(axios.get(`${apiUrl}${new_state.source_info.entity_type}/${new_state.source_info.entity_uuid}/presentations`, { params, ...myHeaders_Auth_With_Cache_Control }));
            api_promises.push(axios.get(`${searchUrl}eventsearch?event_type=community_pk&limit=200`, myHeaders_Auth_With_Cache_Control));
            api_promises.push(axios.get(`${apiUrl}users/${user_entity_uuid}/events?filter_obj=${encodeURIComponent('{"presenter_integer":{"gte":1}}')}`, myHeaders_Auth_With_Cache_Control));            
        } else {
            // org presentations list
            //api_promises.push(axios.get(`${searchUrl}sitesearch?sort_by=created_time&entity_type=presentations&q=${encodeURIComponent(query_filter)}&from=${pagination_from}&limit=${this.pagination_limit}`, myHeaders_With_Cache_Control));


            //do_recursive=true&from=${new_state.presentations_get_from}&limit=${new_state.presentations_get_limit}&sort_obj=${encodeURIComponent('{"created_time":"desc"}')}&filter_obj=${encodeURIComponent('{"status_code":{"ne":2}}')}
            let params = {
                do_recursive: true,
                from: new_state.presentations_get_from,
                limit: new_state.presentations_get_limit,
                sort_obj: {
                    created_time: 'desc'
                },
                filter_obj: {
                    status_code: {
                        ne: 2
                    }
                }
            };
            if (query_filter !== 'all') {
                params.filter_obj.entity_name = { contains: query_filter };
            }

            api_promises.push(axios.get(`${apiUrl}${new_state.source_info.entity_type}/${new_state.source_info.entity_uuid}/presentations`, { params, ...myHeaders_Auth_With_Cache_Control }));
            
        }
        

        let [presentations_response, community_events_response, user_presenter_events_response] = await Promise.all(api_promises);
        
        /*
        if (new_state.source_info.entity_type !== 'users') {
            // put into sane array
            presentations_response.data = presentations_response.data.search_query_results.map((data) => data.entity_info);
        }
        */
        
        /*
        let [presentations_response, community_events_response, user_presenter_events_response] = await Promise.all([
            axios.get(`${user_API}/${user_entity_uuid}/presentations?do_recursive=true&from=${new_state.presentations_get_from}&limit=${new_state.presentations_get_limit}&sort_obj=${encodeURIComponent('{"created_time":"desc"}')}&filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1},"status_code":{"ne":2}}')}`, myHeaders_Auth_With_Cache_Control),
            axios.get(`${searchUrl}eventsearch?event_type=community_pk`),
            axios.get(`${apiUrl}users/${user_entity_uuid}/events?&filter_obj=${encodeURIComponent('{"presenter_integer":{"gte":1}}')}`, myHeaders_Auth_With_Cache_Control)
        ]);
        */

        // put into sane array
        //let community_events_response = community_events_search_response.data.search_query_results.map((data) => data.entity_info);

        // organize possible community events
        let community_events = [];
        let accept_any_format_events = [];
        let community_events_by_format = {};
        
        if (community_events_response && community_events_response.data) {
            let community_events = community_events_response.data.search_query_results.map((data) => data.entity_info);
            console.log( "community_events",community_events);
            if (community_events.length > 0) {
                for (let community_event_info of community_events) {
                    if (community_event_info.event_presentation_format) {
                        if (community_event_info.event_presentation_format === 'any') {
                            accept_any_format_events.push(community_event_info);
                        } else {
                            if (community_events_by_format[community_event_info.event_presentation_format]) {
                                // add to format array
                                community_events_by_format[community_event_info.event_presentation_format].push(community_event_info);
                            } else {
                                // create format array
                                community_events_by_format[community_event_info.event_presentation_format] = [community_event_info];
                            }
                        }
                    }
                }
            }
        }
        
        if (user_presenter_events_response && user_presenter_events_response.data && user_presenter_events_response.data.length > 0) {
            for (let invited_event_info of user_presenter_events_response.data) {
                if (!invited_event_info.event_presentation_format) {
                    invited_event_info.event_presentation_format = '20x20';
                }
                if (invited_event_info.event_presentation_format === 'any') {
                    accept_any_format_events.push(invited_event_info);
                } else {
                    if (community_events_by_format[invited_event_info.event_presentation_format]) {
                        // add to format array
                        community_events_by_format[invited_event_info.event_presentation_format].push(invited_event_info);
                    } else {
                        // create format array
                        community_events_by_format[invited_event_info.event_presentation_format] = [invited_event_info];
                    }
                }
            }
        }
        
        // when auto-refresh, we don't want to keep pushing onto state.presentations_array
        new_state.presentations_array = [];

        // first, to prepare possible events, figure out which events we already have at least one presentation accepted at
        let already_submitted_events = {};
        //console.log(" Presentations response",presentations_response);
        if (presentations_response.headers && presentations_response.headers['x-total-count']) {
            new_state.presentations_get_total = parseInt(presentations_response.headers['x-total-count'],10);
        }
        for (let presentation_obj of presentations_response.data) {
            if (presentation_obj.events && presentation_obj.events.length > 0) {
                for (let event_obj of presentation_obj.events) {
                    if (event_obj.xref_data && event_obj.xref_data.order_integer && event_obj.xref_data.order_integer > 0) {
                        // at least one presentation accepted!
                        //already_submitted_events[event_obj.entity_uuid] = true;
                    //} else if (event_obj.xref_data && event_obj.xref_data.rejected_time) {
                    //    already_submitted_events[event_obj.entity_uuid] = true;
                    //} else if (event_obj.xref_data && event_obj.xref_data.submitted_time) {
                    //    already_submitted_events[event_obj.entity_uuid] = true;
                    }
                }
            }
        }
            
        
        // add important things to presentations_array
        for (let presentation_obj of presentations_response.data) {
            // if this is organization PK that is public, we can only edit it from inside workspace
            if (!this.workspace_base_url && presentation_obj.organizations_uuid) {
                new_state.presentations_get_total--;
                continue;
            }
            
            if (!presentation_obj.public_status) {
                presentation_obj.public_status = 'public';
            }

            if (!presentation_obj.slide_count) {
                presentation_obj.slide_count = 20;
            }
            if (!presentation_obj.slide_length) {
                presentation_obj.slide_length = 20;
            }
            
            // is this publishable (publish checkbox active)? default false
            presentation_obj.publishable = false;
            if (presentation_obj.status_code === 1) {
                presentation_obj.publishable = true;
            } else if (presentation_obj.download_presentation_video_url || presentation_obj.presentation_video_url) {
                presentation_obj.publishable = true;
            }
            
            // is this presentation eligible for a community PK event?
            let tmp_pk_format = presentation_obj.slide_count+'x'+presentation_obj.slide_length;
            
            let possible_community_events = [...accept_any_format_events];
            if (community_events_by_format[tmp_pk_format]) {
                possible_community_events = possible_community_events.concat(community_events_by_format[tmp_pk_format]);
            }
            
            // now filter out events where we already have at least one presentation accepted
            //possible_community_events = possible_community_events.filter(item => !(item.entity_uuid in already_submitted_events));
            
            //possible_community_events.unshift({entity_name:'Submit to an Event'});
            
            // if user is not the presenter for some reaon, do not allow them to submit
            if (!presentation_obj.xref_data || !presentation_obj.xref_data.presenter_integer) {
                presentation_obj.possible_community_events = [];
            }
            
            //possible_community_events.unshift({entity_name:'Submit to an Event'});
            //console.log(" tmp_pk_format",tmp_pk_format,possible_community_events);
            presentation_obj.possible_community_events = possible_community_events;
            
            // is this presentation editable? default true
            presentation_obj.editable = true;
        
            // build useful notes array on presentation status, and adjust editable/publishable based on backend process statuses
            let notes_arr = [];
            if ('current_slide_count' in presentation_obj && presentation_obj.current_slide_count !== presentation_obj.slide_count) {
                // we have not uploaded enough slides    
                notes_arr.push("Missing slides");
            } else if (presentation_obj.video_assembly_method === 'slide_audio') {
                // do nothing
            } else if (presentation_obj.video_assembly_method === 'presentation_audio') {
                if (!presentation_obj.audio_url && !presentation_obj.raw_audio_url) {
                    notes_arr.push("Missing audio");
                }
            } else if (presentation_obj.video_assembly_method === 'presentation_video') {
                if (!presentation_obj.presenter_video_url) {
                    notes_arr.push("Missing audio/video");
                }
            }
            if (presentation_obj.create_presentation_transcript_start_time) {
                if (presentation_obj.create_presentation_transcript_start_time < (get_current_unix_stamp() - 600)) {
                    // over 10 minutes old...something went wrong
                    if (!presentation_obj.create_presentation_transcript_end_time) {
                        notes_arr.push("Transcription failure");
                        presentation_obj.publishable = false;
                    }
                } else {
                    if (!presentation_obj.create_presentation_transcript_end_time) {
                        notes_arr.push("Transcription processing");
                        presentation_obj.publishable = false;
                        presentation_obj.editable = false;
                    }
                }
            }
            if (presentation_obj.trigger_create_presentation_video) {
                notes_arr.push("Video creation processing");
                presentation_obj.editable = false;
                presentation_obj.publishable = false;
            } else if (presentation_obj.create_presentation_video_start_time) {
                if (presentation_obj.create_presentation_video_start_time < (get_current_unix_stamp() - 600)) {
                    // over 10 minutes old...something went wrong
                    if (!presentation_obj.create_presentation_video_end_time) {
                        notes_arr.push("Video creation failure");
                        presentation_obj.publishable = false;
                        if (presentation_obj.processing_error_message) {
                            notes_arr.push(presentation_obj.processing_error_message);
                        }
                    }
                } else {
                    if (!presentation_obj.create_presentation_video_end_time) {
                        notes_arr.push("Video creation processing");
                        presentation_obj.editable = false;
                        presentation_obj.publishable = false;
                    }
                }
            }
            
            if (presentation_obj.editable) {
                if ((!presentation_obj.download_presentation_video_url && !presentation_obj.presentation_video_url)) {
                    presentation_obj.publishable = false;
                    if (user_Status_Ver === "3") {
                        notes_arr.push("Email verification required to create video");
                    } else {
                        notes_arr.push("Edit audio to create video");
                        /*
                        if (presentation_obj.status_code === 1) {
                            // this should not happen?
                            notes_arr.push("Edit audio to create video");
                        } else {
                            notes_arr.push("Edit audio to create video");
                        }
                        */
                    }
                } else {
                    if (presentation_obj.create_presentation_video_start_time > (get_current_unix_stamp() - 600) || presentation_obj.create_presentation_transcript_start_time > (get_current_unix_stamp() - 600)) {
                        // video or transcript recently kicked off...indicate cooldown and don't let them edit yet
                        notes_arr.push("Video or transcript recently processed");
                        presentation_obj.editable = false;
                    }
                }
            }
            
            if (presentation_obj.events) {
                // sort by oldest first
                presentation_obj.events = presentation_obj.events.sort((a, b) => (a.start_time < b.start_time) ? 1 : -1);
            }
            
            let found_accepted_event = false;
            if (presentation_obj.events && presentation_obj.events.length > 0) {
                // build more useful event data and incorporate community PK submit/accept/reject status  
                for (let i = 0; i < presentation_obj.events.length; i++) {
                    if (presentation_obj.events[i].xref_data && presentation_obj.events[i].xref_data.order_integer && presentation_obj.events[i].xref_data.order_integer > 0) {
                        //console.log("ACCEPTED",i);
                        // accepted!
                        found_accepted_event = true;
                        if (presentation_obj.events[i].status_code === 1) {
                            presentation_obj.event_entity_name = presentation_obj.events[i].entity_name;
                            presentation_obj.event_friendly_url = presentation_obj.events[i].friendly_url;
                        } else if (presentation_obj.events[i].status_code === 4) {
                            presentation_obj.event_entity_name = presentation_obj.events[i].entity_name;
                        }
                        
                        // also remove from possible community events array
                        presentation_obj.possible_community_events = presentation_obj.possible_community_events.filter(item => item.entity_uuid !== presentation_obj.events[i].entity_uuid);

                        //break;
                    } else if (presentation_obj.events[i].xref_data && presentation_obj.events[i].xref_data.rejected_time) {
                        // submitted then rejected
                        //console.log("REJECTED!",i);
                        if (presentation_obj.events[i].status_code === 1) {
                            notes_arr.push("Rejected from event "+presentation_obj.events[i].entity_name);
                            presentation_obj.possible_community_events = presentation_obj.possible_community_events.filter(item => item.entity_uuid !== presentation_obj.events[i].entity_uuid);
                        }
                        
                        // also remove from possible community events array
                        presentation_obj.possible_community_events = presentation_obj.possible_community_events.filter(item => item.entity_uuid !== presentation_obj.events[i].entity_uuid);
                        //} else if (presentation_obj.events[i].status_code === 4) {
                            //presentation_obj.event_entity_name = presentation_obj.events[0].entity_name;
                        //}
    
                    } else if (presentation_obj.events[i].xref_data && presentation_obj.events[i].xref_data.submitted_time) {
                        // submitted
                        if (!found_accepted_event) {
                            // only report this when we don't already have an accepted event
                            if (presentation_obj.events[i].status_code === 1) {
                                presentation_obj.event_entity_name = presentation_obj.events[i].entity_name+' (Submitted)';
                                presentation_obj.event_friendly_url = presentation_obj.events[i].friendly_url;
                            } else if (presentation_obj.events[i].status_code === 4) {
                                presentation_obj.event_entity_name = presentation_obj.events[i].entity_name;
                            }
                        }
                        
                        // also remove from possible community events array
                        presentation_obj.possible_community_events = presentation_obj.possible_community_events.filter(item => item.entity_uuid !== presentation_obj.events[i].entity_uuid);
                    }
                }
            }
            
            // build final notes string
            if (presentation_obj.status_code === 1) {
                // published
                let notes = "";
                if (presentation_obj.view_count) {
                    notes_arr.push('View Count: '+presentation_obj.view_count);
                } else {
                    notes_arr.push('View Count: 0');
                }
                if (notes_arr.length > 0 ) {
                    notes = notes_arr.join(', ');
                }
                presentation_obj.notes = notes;
            } else if (presentation_obj.status_code === 4 && !presentation_obj.auto_publish) {
                // draft - no auto_publish
                let notes = "";
                if (notes_arr.length > 0 ) {
                    notes = notes_arr.join(', ');
                } else {
                    notes = "Ready to publish!";
                }
                presentation_obj.notes = notes;
            } else if (presentation_obj.status_code === 4) {
                // draft - auto_publish on (pending)
                let notes = "";
                if (notes_arr.length > 0 ) {
                    notes = notes_arr.join('; ');
                } else {
                    notes = "Ready to publish!";
                }
                presentation_obj.notes = notes;
            }

            new_state.presentations_array.push(presentation_obj);
        }
        
        new_state.loading = false;
        new_state.table_loading = false;

        this.setState(new_state);
 
    }

    // OnClick Edit button
    editPkData = (data) => {
        this.props.history.push(`${this.workspace_base_url}${local_routes.pkcreation}/${data.entity_uuid}/description`)
        window.location.reload();
    }
    
    OnChangePublishOption = async (publish_obj, presentationData, presentation_index) => {
        console.log("OnChangePublishOption",publish_obj,presentationData,presentation_index);
        let patch_obj = {
            //status_code: publish_obj.status_code
        }
        if (this.workspace_base_url || user_account_level === 'private') {
            patch_obj.public_status = publish_obj.public_status
        }
        
        //await axios.patch(`${apiUrl}presentations/${presentationData.entity_uuid}`,patch_obj);
        let tmp_presentations_array = [...this.state.presentations_array];

        tmp_presentations_array[presentation_index].public_status = publish_obj.public_status;


        // bust cache if not draft
        //if (presentationData.status_code === 1) {
            //axios.get(`${presentation_Creation_API}/${presentationData.friendly_url}`, myHeaders_Auth_With_Cache_Control);
        //}
        this.setState({
            presentations_array: tmp_presentations_array
        });
    }
    
    togglePublish = async (status, presentationData, presentation_index) => {
        let status_code = (status === true) ? 1 : (status === false) ? 4 : null;
        const payload = {
            status_code: status_code
        };
        if (status_code !== null && status_code !== undefined) {
            await axios.patch(`${apiUrl}presentations/${presentationData.entity_uuid}`,payload);
            let tmp_presentations_array = [...this.state.presentations_array];
            tmp_presentations_array[presentation_index].status_code = status_code;
            this.setState({
                presentations_array: tmp_presentations_array
            });
        }
    }
    
    OnDeletePresentation = async (presentation_uuid, presentation_index) => {
        let patch_obj = {
            status_code: 2
        };
        await axios.patch(`${apiUrl}presentations/${presentation_uuid}`,patch_obj);
        let tmp_presentations_array = [...this.state.presentations_array];
        tmp_presentations_array.splice(presentation_index,1); // remove from array
        this.setState({
            presentations_array: tmp_presentations_array
        });
    }
    
    OnDuplicatePresentation = async (presentation_uuid, presentation_index, organizations_friendly_url = null) => {
        if (organizations_friendly_url) {
            await axios.post(`${apiUrl}presentations/${presentation_uuid}/duplicate?organizations_friendly_url=${organizations_friendly_url}`,{});
        } else {
            await axios.post(`${apiUrl}presentations/${presentation_uuid}/duplicate`,{});
        }
        await this.APICalls(); // refresh from database
        window.scrollTo(0, 0);
    }

    /*
    // unused for now
    togglePublic = (status,data) => {
        let public_status = '';
        if (status === false) {
            public_status = 'private';
        } else {
            public_status = 'public';
        }
        let patch_obj = {
            public_status
        }
        axios.patch(`${apiUrl}presentations/${data.entity_uuid}`,patch_obj);
    }
    */
    

    OnSubmitCommunityPk = async (presentation_info,community_event_index) => {
        // note that index here will be actual index in community events
        console.log("OnSubmitCommunityPk",presentation_info.entity_uuid,presentation_info.possible_community_events[community_event_index].entity_uuid);
    
        let patch_obj = {
            events: [
                {
                    entity_uuid: presentation_info.possible_community_events[community_event_index].entity_uuid,
                    xref_data: {
                        submitted_time: Math.floor(new Date().getTime() / 1000)
                    }
                }
            ]
        }
    
        await axios.patch(`${apiUrl}presentations/${presentation_info.entity_uuid}`,patch_obj);
        
        await this.APICalls();
    }

    OnPaginateCallback = async (page_number) => {
        console.log("OnPaginateCallback",page_number);
        
        let tmp_from = (page_number - 1) * this.state.presentations_get_limit;
        console.log("OnPaginateCallback",page_number,tmp_from);
        this.setState({
           table_loading: true,
           presentations_get_from:tmp_from,
           presentations_page_number:page_number
        });
        await this.APICalls({presentations_get_from:tmp_from,presentations_page_number:page_number});
    }

    checkForEnter = async (event) => {
        if (event.key === "Enter") {
            console.log("Enter pressed!");
            if (event.target.id === 'search_text') {
                this.setState({ loading: true });
                //await this.getUsersFromApi({pagination_from:0,search_text:event.target.value});
                await this.APICalls({presentations_get_from:0,search_text:event.target.value});
            }
        }
    }

    handleChangeFilterValue = async (event) => {
        this.setState({
           [event.target.id]: event.target.value
        });
    }
    
    clearSearch = () => {
        this.setState({ loading: true });
        this.APICalls({presentations_get_from:0,search_text:""});
    }

    render() {

        //const {
            //pageLoader,
            //pendingData,
            //friendlyPkUrl,
            //publishData,
            //draftData,
            //tableHeader } = this.state;
        // let draftDataLen = draftData.length;
        //let publishDataLen = publishData.length;let pendingDataLen = pendingData.length;
        if (this.state.loading) {
            return (
                <ActivityIndicator theme="button-Status-Loader"/>
            )
        }

            return (
                
                <React.Fragment>
                                <Container style={{ marginTop: "15px", paddingRight: "0px", paddingLeft: "0px" }}>
                                    <Row noGutters className="justify-content-between" style={{ lineHeight: "2" }}>
                                        <Col md={8} xs={8}>
                                            <div className="search-nav">
                                                <i className="fa fa-search nav-search"></i>
                                                <input
                                                    style={{ border:"1px solid #d7d8da"}}
                                                    type="text"
                                                    autoFocus
                                                    value={this.state.search_text}
                                                    id="search_text"
                                                    onChange={this.handleChangeFilterValue}
                                                    onKeyPress={this.checkForEnter}
                                                    placeholder={`Search/Filter ${this.props.source_info.entity_name || 'Your'} Presentations`}
                                                />
                                            </div>
                                        </Col>
                                        <Col md={4} xs={4} className="flex justify-content-end">
                                            <Button
                                              variant="pkprimary"
                                              //style={{marginTop:"0px"}}
                                              onClick={this.clearSearch}
                                              className="clear-search-button"
                                            >
                                                Clear Search
                                            </Button>
                                        </Col>
                                    </Row>
                                </Container>
                                { this.state.presentations_array.length > 0 &&
                                      <div style={{ marginTop: "10px" }} className="table-boby channel-events-list">
                                        <Table variant={this.context.theme} responsive={true}>
                                            <tbody>
                                                
                                                <TableHeader
                                                    theme={this.context.theme}
                                                    tableHeader={this.state.tableHeader}
                                                    displayed_list_length={this.state.presentations_array.length}
                                                    total_list_length={this.state.presentations_get_total}
                                                    current_page_number={this.state.presentations_page_number}
                                                    from={this.state.presentations_get_from}
                                                    limit={this.state.presentations_get_limit}
                                                    OnPaginateCallback={this.OnPaginateCallback}
                                                />
                                                
                                                { this.state.table_loading &&
                                                    <tr><td colSpan={Object.keys(this.state.tableHeader).length}><ActivityIndicator theme="button-Status-Loader justify-content-center" /></td></tr>
                                                }
                                                {
                                                    !this.state.table_loading && this.state.presentations_array.map((item, i) => {
                                                        return (
                                                            <PkListTableV2
                                                                source_info={this.state.source_info}
                                                                key={item.entity_uuid}
                                                                index={i}
                                                                presentation_info={item}
                                                                user_access_level={user_access_level}
                                                                organization_user_access_level={organization_user_access_level}
                                                                user_account_level={user_account_level}
                                                                user_status_code={user_Status_Ver}
                                                                togglePublish={this.togglePublish}
                                                                workspace_base_url={this.workspace_base_url}
                                                                user_organizations={(this.context.user_info && this.context.user_info.organizations) ? this.context.user_info.organizations.filter(item => item.friendly_url !== org_friendly_url) : []}
                                                                OnSubmitCommunityPk={this.OnSubmitCommunityPk}
                                                                OnDeletePresentation={this.OnDeletePresentation}
                                                                OnDuplicatePresentation={this.OnDuplicatePresentation}
                                                                OnChangePublishOption={this.OnChangePublishOption}
                                                                referrer={this.props.referrer}
                                                            />
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                      </div>
                                    
                                }
                                {/*
                                <div style={{ marginTop: "10px" }} className="table-boby" style={{ overflow: 'visible' }}>
                                </div>
                                */}
                                { this.state.presentations_array.length === 0 &&
                                    <EmptyMessage empty_message="No Presentations to show" />
                                }


                </React.Fragment>
                
            );

    }
}

export default withRouter(PkList);
